import React from 'react'

export const TrendDown = (props) => (
  <svg
    width="16"
    height="10"
    viewBox="0 0 16 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10.6713 8.59859H14.4736L8.89506 2.93662L5.64788 6.23239C5.48135 6.4014 5.17606 6.4014 5.00954 6.23239L0.124892 1.27465C-0.0416305 1.10564 -0.0416305 0.795775 0.124892 0.62676C0.29141 0.457747 0.596702 0.457747 0.763228 0.62676L5.34258 5.27464L8.56198 1.97887C8.72852 1.80986 9.03382 1.80986 9.20036 1.97887L15.1119 7.97886V4.09155C15.1119 3.8662 15.3061 3.64084 15.5559 3.64084C15.778 3.64084 16 3.8662 16 4.09155V9.0493C16 9.30284 15.778 9.5 15.5559 9.5H10.6713C10.4215 9.5 10.2272 9.30284 10.2272 9.0493C10.2272 8.82394 10.4215 8.59859 10.6713 8.59859Z"
      fill="#000000"
    />
  </svg>
)
